<template>
  <v-app>
    <div
      class="loan_wrapper"
      v-if="editedItem"
      v-loading="saveLoading"
    >
      <div class="page page1">
        <div class="loan_header">
          <h1>和潤企業車輛分期付款申請書</h1>
        </div><!--header-->
        <div class="top">
          <div class="top-nb">
            合約編號：<input type="text" v-model="editedItem.displayId">
          </div>
          <div class="top-date">
            申請日期：
            <span class="y">
                <select class v-model="editedItem.applyDate.year">
                  <option v-for="year in yearList" :key="year.key" :value="year.key">{{year.name}}</option>
                </select>
              </span>年
            <span class="m">
                <select class v-model="editedItem.applyDate.month">
                  <option v-for="month in monthList" :key="month.key" :value="month.key">{{month.name}}</option>
                </select>
              </span>月
            <span class="d">
                <select class v-model="editedItem.applyDate.day">
                  <option v-for="day in dayList" :key="day.key" :value="day.key">{{day.name}}</option>
                </select>
              </span>日
            <!-- <input type="text"   class="y">年
            <input type="text"   class="m">月
            <input type="text"   class="d">日 -->
          </div>
          <div class="top-ps">原申請條件如下：(核准與否與實際貸款條件，以本公司最終核決結果為準)</div>
        </div><!--top-->
        <div class="area1">
          <table class="table1">
            <thead>
            <tr>
              <th colspan="4">
                申貸產品
                <div class="con1">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.laonhfcInfo.project0"></span>本牌新車
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.laonhfcInfo.project1"></span>他牌新車
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.laonhfcInfo.project2"></span>中古車
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.laonhfcInfo.project3"></span>原融
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.laonhfcInfo.project4"></span>借新還舊
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.laonhfcInfo.project5"></span>他行代償
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.laonhfcInfo.project6"></span>機車
                </div>
              </th>
              <th width="177px" class="th1 thEnd">*本牌新車需額外填寫</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td width="157px">
                <span class="tdTit tdTit1">*經銷商：</span>
                <div class="con2">
                  <textarea></textarea>
                </div>
              </td>
              <td width="157px">
                <span class="tdTit tdTit2">*營業所：</span>
                <div class="con3">
                  <textarea></textarea>
                </div>
              </td>
              <td width="147px">
                <span class="tdTit tdTit3">*車商業代：</span>
                <div class="con4">
                  <textarea></textarea>
                </div>
              </td>
              <td colspan="2" class="tdEnd">
                <span class="tdTit tdTit4">*專案名稱：</span>
                <div class="con5">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.laonhfcInfo.zeroRate"></span>零利率
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.laonhfcInfo.otherProject"></span><textarea v-model="editedItem.laonhfcInfo.projectName"></textarea>
                  <span class="txt">專案</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="tdTit tdTit5">廠牌：</span>
                <div class="con6">
                  <textarea v-model="editedItem.laonhfcInfo.vendor"></textarea>
                </div>
              </td>
              <td>
                <span class="tdTit tdTit6">車名：</span>
                <div class="con7">
                  <textarea v-model="editedItem.laonhfcInfo.name"></textarea>
                </div>
              </td>
              <td>
                <span class="tdTit tdTit7">出廠年月：</span>
                <div class="con8">
                  <select v-model="editedItem.laonhfcInfo.publicYear">
                    <option
                      v-for="year in publicYearList"
                      :key="year.key"
                      :value="year.key"
                    >{{year.name}}</option>
                  </select>年
                  <select v-model="editedItem.laonhfcInfo.publicMonth">
                    <option
                      v-for="month in publicMonthList"
                      :key="month.key"
                      :value="month.key"
                    >{{month.name}}</option>
                  </select>月
                </div>
              </td>
              <td>
                <span class="tdTit tdTit8">車號：</span>
                <div class="con9">
                  <input type="text" v-model="editedItem.laonhfcInfo.carId">
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit9">*折讓前車價：NT</span>
                <div class="con10">
                  <input type="text"  >
                  <span class="txt">元</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="tdTit tdTit10">*買賣價：NT</span>
                <div class="con11">
                  <input type="text"  >
                  <span class="txt">元</span>
                </div>
              </td>
              <td>
                <span class="tdTit tdTit11">參考價：NT</span>
                <div class="con12">
                  <input type="text"  >
                  <span class="txt">元</span>
                </div>
              </td>
              <td colspan="2">
                <span class="tdTit tdTit12">參考來源：</span>
                <div class="con13">
                  <span class="checkbox"><input type="checkbox"></span>HOT
                  <span class="checkbox"><input type="checkbox"></span>權威
                  <span class="checkbox"><input type="checkbox"></span>天書
                  <span class="checkbox"><input type="checkbox"></span>其他
                  <textarea></textarea>
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit13">承辦人：</span>
                <div class="con14">
                  <input type="text"  >
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table1-->
          <table class="table2">
            <tbody>
            <tr>
              <td width="157px">
                <span class="tdTit tdTit14">貸款金額：NT</span>
                <div class="con15">
                  <input type="text" v-model="editedItem.vendor.totalPrice">
                  <span class="txt">元</span>
                </div>
              </td>
              <td width="157px">
                <span class="tdTit tdTit15">貸款期數：</span>
                <div class="con16">
                  <input type="text" v-model="editedItem.vendor.installmentsNumber">
                  <span class="txt">期</span>
                </div>
              </td>
              <td width="147px">
                <span class="tdTit tdTit16">期付款：NT</span>
                <div class="con17">
                  <input type="text" v-model="editedItem.vendor.creditPriceMonth">
                  <span class="txt">元</span>
                </div>
              </td>
              <td width="140px">
                <span class="tdTit tdTit17">利率：</span>
                <div class="con18">
                  <input type="text"  >
                  <span class="txt">%</span>
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit18">*補貼款：NT</span>
                <div class="con19">
                  <input type="text"  >
                  <span class="txt">元</span>
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table2-->
        </div><!--area1-->
        <div class="area2">
          <table class="table3">
            <thead>
            <tr>
              <th>公司戶</th>
            </tr>
            </thead>
          </table><!--table3-->
          <table class="table4">
            <tbody>
            <tr>
              <td width="373px">
                <span class="tdTit tdTit19">公司名稱：</span>
                <div class="con20">
                  <input type="text">
                </div>
                <div class="con21">
                  <span class="checkbox"><input type="checkbox"></span>有限公司<br/>
                  <span class="checkbox"><input type="checkbox"></span>股份有限公司
                </div>
              </td>
              <td width="157px">
                <span class="tdTit tdTit20">統一編號：</span>
                <div class="con22">
                  <input type="text" v-model="editedItem.company.companyId">
                </div>
              </td>
              <td width="120px">
                <span class="tdTit tdTit21">設立日期：</span>
                <div class="con23">
                  <input type="text"   class="y">年
                  <input type="text"   class="m">月
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit22">資本額:NT</span>
                <div class="con24">
                  <input type="text"  >
                  <span class="txt">元</span>
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table4-->
          <table class="table5">
            <tbody>
            <td width="490px">
              <span class="tdTit tdTit23">公司地址：</span>
              <div class="con25">
                <input type="text">
                <input type="text">
                <input type="text">
              </div>
              <div class="con26">
                <input type="text">
              </div>
            </td>
            <td width="159px">
              <span class="tdTit tdTit24">電話：</span>
              <div class="con27">
                <input type="text">
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit tdTit25">年營業額:NT</span>
              <div class="con28">
                <input type="text"  >
                <span class="txt">元</span>
              </div>
            </td>
            </tbody>
          </table><!--table5-->
        </div><!--area2-->
        <div class="area3">
          <table class="table6">
            <thead>
            <tr>
              <th colspan="4">
                申請人基本資料(個人戶或公司負責人)
                <div class="con29">
                  <span class="checkbox"><input type="checkbox"></span>負責人兼保證人
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td width="168px">
                <span class="tdTit tdTit26">姓名：</span>
                <div class="con30">
                  <input type="text" v-model="editedItem.customer.name">
                </div>
              </td>
              <td width="205px">
                <span class="tdTit tdTit27">身分證字號：</span>
                <div class="con31">
                  <input type="text" v-model="editedItem.customer.memberId">
                </div>
              </td>
              <td width="157px">
                <span class="tdTit tdTit28">生日：</span>
                <div class="con32">
                  <input type="text" v-model="editedItem.customer.birthdayInfo.year"  class="y">年<input type="text"  v-model="editedItem.customer.birthdayInfo.month" class="m">月<input type="text" v-model="editedItem.customer.birthdayInfo.day"  class="d">日
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit29">婚姻狀態：</span>
                <div class="con33">
                      <span class="checkbox">
                        <input type="checkbox" v-model="editedItem.customer.married[0].value"
                               :checked="editedItem.customer.married[0].value === true"></span>已婚
                  <span class="checkbox">
                        <input type="checkbox" v-model="editedItem.customer.married[1].value"
                               :checked="editedItem.customer.married[1].value === true"></span>未婚
                  <span class="checkbox"><input type="checkbox"></span>其他
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table6-->
          <table class="table7">
            <tbody>
            <tr>
              <td width="305px">
                <span class="tdTit tdTit30">學歷：</span>
                <div class="con34">
                      <span class="checkbox">
                        <input type="checkbox" v-model="editedItem.customer.educationLevel[1].value">
                      </span>碩士以上
                  <span class="checkbox">
                        <input type="checkbox" v-model="editedItem.customer.educationLevel[2].value">
                      </span>大學
                  <span class="checkbox">
                        <input type="checkbox" v-model="editedItem.customer.educationLevel[3].value">
                      </span>專科
                  <span class="checkbox">
                        <input type="checkbox" v-model="editedItem.customer.educationLevel[4].value">
                      </span>高中職
                  <span class="checkbox">
                        <input type="checkbox" v-model="editedItem.customer.educationLevel[5].value">
                        </span>初中及以下
                </div>
              </td>
              <td width="225px">
                <span class="tdTit tdTit31">月收入：NT</span>
                <div class="con35">
                  <input type="text" v-model="editedItem.company.salary">
                  <span class="txt">元</span>
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit32"  >行業別：</span>
                <div class="con36">
                  <input type="text" v-model="editedItem.company.industry" >
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table7-->
          <table class="table8">
            <tbody>
            <tr>
              <td width="374px">
                <span class="tdTit tdTit33">任職公司：</span>
                <div class="con37">
                  <input type="text" v-model="editedItem.company.name">
                </div>
              </td>
              <td width="236px">
                <span class="tdTit tdTit34">職稱：</span>
                <div class="con38">
                  <input type="text" v-model="editedItem.company.title">
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit35">年資：</span>
                <div class="con39">
                  <input type="text" v-model="editedItem.company.workYear">
                  <span class="txt">年</span>
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table8-->
          <table class="table9">
            <tbody>
            <tr>
              <td width="530px">
                <span class="tdTit tdTit36">戶籍地址：</span>
                <input type="text" value="" placeholder="郵遞區號" v-model="editedItem.customer.home.residencePost" class="con89">
                <input type="text" value="" placeholder="縣市" v-model="editedItem.customer.home.residenceCity" class="con90">
                <input type="text" value="" placeholder="區鄉鎮" v-model="editedItem.customer.home.residenceArea" class="con91">
                <input type="text" value="" placeholder="地址" v-model="editedItem.customer.home.residenceAddress" class="con92">
<!--                <div class="con40">-->
<!--                  <input type="text"  >-->
<!--                  <input type="text"  >-->
<!--                  <input type="text"  >-->
<!--                </div>-->
<!--                <div class="con41">-->
<!--                  <input type="text" v-model="editedItem.customer.home.residenceContent">-->
<!--                </div>-->
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit37">戶籍電話：</span>
                <div class="con42">
                  <input type="text" v-model="editedItem.customer.phone">
                </div>
                <div class="con43">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.customer.home.liveLevel[0].value"></span>自有
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.customer.home.liveLevel[1].value"></span>家人
                  <input type="text" class="input1"><br>
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.customer.home.liveLevel[3].value"></span>租賃，&nbsp;居住
                  <input type="text" class="input2" v-model="editedItem.customer.home.liveYear">年
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="tdTit tdTit38">通訊地址：</span>
                <input type="text" value="" placeholder="郵遞區號" v-model="editedItem.customer.home.homePost"  class="con89">
                <input type="text" value="" placeholder="縣市" v-model="editedItem.customer.home.homeCity"  class="con90">
                <input type="text" value="" placeholder="區鄉鎮" v-model="editedItem.customer.home.homeArea"  class="con91">
                <input type="text" value="" placeholder="地址" v-model="editedItem.customer.home.homeAddress1"  class="con93">
<!--                <div class="con44">-->
<!--                  <input type="text"  >-->
<!--                  <input type="text"  >-->
<!--                  <input type="text"  >-->
<!--                </div>-->
<!--                <div class="con45">-->
<!--                  <input type="text" v-model="editedItem.customer.home.homeContent">-->
<!--                </div>-->
                <div class="con45-1">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.customer.home.homeType1[0].value"></span>同戶籍<br>
                  <span class="checkbox"><input type="checkbox"></span>同公司
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit39">通訊電話：</span>
                <div class="con46">
                  <input type="text" v-model="editedItem.customer.homePhone">
                </div>
                <div class="con47">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.customer.home.liveLevel2[0].value"></span>自有
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.customer.home.liveLevel2[1].value"></span>家人
                  <input type="text"   class="input1"><br>
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.customer.home.liveLevel2[3].value"></span>租賃，&nbsp;居住
                  <input type="text"   class="input2" v-model="editedItem.customer.home.liveYear2">年
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table9-->
          <table class="table10">
            <tbody>
            <tr>
              <td width="530px">
                <span class="tdTit tdTit40">公司地址：</span>
                <div class="con48">
                  <input type="text"  >
                  <input type="text"  >
                  <input type="text"  >
                </div>
                <div class="con49">
                  <input type="text" v-model="editedItem.company.address">
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit41">公司電話：</span>
                <div class="con50">
                  <input type="text" v-model="editedItem.company.phone">
                </div>
                <span class="tdTit tdTit42">分機</span>
                <div class="con51">
                  <input type="text"  >
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="tdTit tdTit43">E-mail：</span>
                <div class="con52">
                  <input type="text" v-model="editedItem.customer.email">
                  <span class="txt">(數字0請以<span class="icon"></span>書寫)</span>
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit44">行動電話：</span>
                <div class="con53">
                  <input type="text" v-model="editedItem.customer.cellphone">
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table10-->
          <table class="table11">
            <tr>
              <th rowspan="2" width="30px">
                <span class="tdTit tdTit45">繳款<br/>方式</span>
              </th>
              <td>
                <div class="con55">
                  數位繳款
                  <div class="con55-1">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isAPPPay"></span>APP
                  </div>
                  <div class="con56">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isLINEPay"></span>LINE
                  </div>
                  <div class="con57">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isEmailPay"></span>Email
                  </div>
                  <div class="con58">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isSMSPay"></span>簡訊
                  </div>
                  <div class="con59">
                    (以上四者皆可至四大超商/ATM/網銀/銀行/郵局繳款)
                  </div>
                  <div class="con60">
                    自動扣款
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isAutoEDDAPay"></span>eDDA
                  </div>
                  <div class="con60-1">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isAutoBillPay"></span>ACH
                  </div>
                </div>
<!--                <div class="con54">-->
<!--                  <span class="checkbox"><input type="checkbox"></span>1.支票&nbsp;&nbsp;(※請填寫&nbsp;&nbsp;銀行<input type="text"   class="input1">分行<input type="text"   class="input2">戶名<input type="text"   class="input3">帳號<input type="text"   class="input4">)-->
<!--                </div>-->
              </td>
            </tr>
            <tr>
              <td>
                <div class="con54">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isBankPay"></span>支票繳款<span class="con54-0">(&nbsp;*&nbsp;請填寫</span>銀行<input type="text" v-model="editedItem.paymentInfo.bankName" class="input1">分行<input type="text" v-model="editedItem.paymentInfo.bankSubName" class="input2">戶名<input type="text" v-model="editedItem.paymentInfo.accountName" class="input3">帳號<input type="text"  v-model="editedItem.paymentInfo.bankAccountNo" class="input4">)
                </div>
<!--                <div class="con55">-->
<!--                    <span class="checkbox">-->
<!--                      <input type="checkbox"-->
<!--                             @click="paymentSlip(0)"-->
<!--                             v-model="editedItem.paymentInfo.debitNote.isDebitNote"-->
<!--                      ></span>2.繳款單&nbsp;&nbsp;(※請選擇寄送地址-->
<!--                  <div class="con56">-->
<!--                      <span class="checkbox"><input type="checkbox"-->
<!--                                                    @click="paymentSlip(1)"-->
<!--                                                    v-model="editedItem.paymentInfo.debitNote.isRegistration"></span>戶籍地址-->
<!--                  </div>-->
<!--                  <div class="con57">-->
<!--                      <span class="checkbox"><input type="checkbox" @click="paymentSlip(2)"-->
<!--                                                    v-model="editedItem.paymentInfo.debitNote.isMailingAddress"></span>通訊地址-->
<!--                  </div>-->
<!--                  <div class="con58">-->
<!--                      <span class="checkbox"><input type="checkbox" @click="paymentSlip(3)"-->
<!--                                                    v-model="editedItem.paymentInfo.debitNote.isCompanyAddress"></span>公司地址&nbsp;&nbsp;/-->
<!--                  </div>-->
<!--                  <div class="con59">-->
<!--                    <span class="checkbox"><input type="checkbox"></span>不寄，自行下載和潤客戶&nbsp;APP-->
<!--                  </div>-->
<!--                  <div class="con60">-->
<!--                      <span class="checkbox"><input type="checkbox" @click="autoPayment"-->
<!--                                                    v-model="editedItem.paymentInfo.isAutoBillPay"></span>3.ACH&nbsp;自動扣繳-->
<!--                  </div>-->
<!--                </div>-->
              </td>
            </tr>
          </table>
          <table class="table12">
            <tr>
              <th width="30px">
                <span class="tdTit tdTit46">不動<br/>產</span>
              </th>
              <td>
                <div class="con61">
                  地段<input type="text"   class="input1">地號<input type="text"   class="input2">建號<input type="text"   class="input3">建物門牌<input type="text"   class="input4">所有權人：
                </div>
                <div class="con62">
                  <span class="checkbox"><input type="checkbox"></span>車主<br/>
                  <span class="checkbox"><input type="checkbox"></span>保人<input type="text"   class="input1">
                </div>
              </td>
            </tr>
          </table><!--table12-->
        </div><!--area3-->
        <div class="area4">
          <table class="table13">
            <thead>
            <tr>
              <th colspan="5">保證人一</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td width="170px">
                <span class="tdTit tdTit47">姓名：</span>
                <div class="con63">
                  <input type="text" v-model="editedItem.jointGuarantor.name">
                </div>
              </td>
              <td width="205px">
                <span class="tdTit tdTit48">身分證字號：</span>
                <div class="con64">
                  <input type="text" v-model="editedItem.jointGuarantor.memberId">
                </div>
              </td>
              <td width="157px">
                <span class="tdTit tdTit49">生日：</span>
                <div class="con65">
                  <input type="text" v-model="editedItem.jointGuarantor.birthdayInfo.year"  class="y">年<input type="text" v-model="editedItem.jointGuarantor.birthdayInfo.month"  class="m">月<input type="text" v-model="editedItem.jointGuarantor.birthdayInfo.day" class="d">日
                </div>
              </td>
              <td width="157px">
                <span class="tdTit tdTit50">婚姻狀態：</span>
                <div class="con66">
                      <span class="checkbox">
                        <input type="checkbox">
                      </span>已婚
                  <span class="checkbox">
                        <input type="checkbox">
                      </span>未婚
                  <span class="checkbox">
                        <input type="checkbox">
                      </span>其他
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit51">關係：</span>
                <div class="con67">
                  <input type="text" v-model="editedItem.jointGuarantor.type">
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table13-->
          <table class="table14">
            <tbody>
            <tr>
              <td width="305px">
                <span class="tdTit tdTit52">學歷：</span>
                <div class="con68">
                  <span class="checkbox"><input type="checkbox"></span>碩士以上<span class="checkbox"><input type="checkbox"></span>大學<span class="checkbox"><input type="checkbox"></span>專科<span class="checkbox"><input type="checkbox"></span>高中職<span class="checkbox"><input type="checkbox"></span>初中及以下
                </div>
              </td>
              <td width="227px">
                <span class="tdTit tdTit53">月收入：</span>
                <div class="con69">
                  <input type="text"  >
                  <span class="txt">元</span>
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit54">行業別：</span>
                <div class="con70">
                  <input type="text"  >
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table14-->
          <table class="table15">
            <tbody>
            <tr>
              <td width="374px">
                <span class="tdTit tdTit55">任職公司：</span>
                <div class="con71">
                  <input type="text" v-model="editedItem.jointGuarantor.companyName">
                </div>
              </td>
              <td width="236px">
                <span class="tdTit tdTit56">職稱：</span>
                <div class="con72">
                  <input type="text" v-model="editedItem.jointGuarantor.title">
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit57">年資：</span>
                <div class="con73">
                  <input type="text" v-model="editedItem.jointGuarantor.workYear">
                  <span class="txt">年</span>
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table15-->
          <table class="table16">
            <tbody>
            <tr>
              <td width="532px">
                <span class="tdTit tdTit58">戶籍地址：</span>
                <div class="con74">
                  <input type="text">
                  <input type="text">
                  <input type="text">
                </div>
                <div class="con75">
                  <input type="text" v-model="editedItem.jointGuarantor.home.residenceAddress">
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit59">戶籍電話：</span>
                <div class="con76">
                  <input type="text" v-model="editedItem.jointGuarantor.phone">
                </div>
                <div class="con77">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel[0].value"></span>自有
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel[1].value"></span>家人<input type="text"   class="input1"><br>
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel[3].value"></span>租賃，&nbsp;居住
                  <input type="text" class="input2" v-model="editedItem.jointGuarantor.home.liveYear">年
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="tdTit tdTit60">通訊地址：</span>
                <div class="con78">
                  <input type="text"  >
                  <input type="text"  >
                  <input type="text"  >
                </div>
                <div class="con79">
                  <input type="text" v-model="editedItem.jointGuarantor.home.homeAddress1">
                </div>
                <div class="con79-1">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType1[0].value"></span>同戶籍<br>
                  <span class="checkbox"><input type="checkbox"></span>同公司
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit61">通訊電話：</span>
                <div class="con80">
                  <input type="text" v-model="editedItem.jointGuarantor.homePhone">
                </div>
                <div class="con81">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel2[0].value"></span>自有
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel2[1].value"></span>家人<input type="text"   class="input1"><br>
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.jointGuarantor.home.liveLevel2[3].value"></span>租賃，&nbsp;居住
                  <input type="text"  class="input2" v-model="editedItem.jointGuarantor.home.liveYear2">年
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table16-->
          <table class="table17">
            <tbody>
            <tr>
              <td width="532px">
                <span class="tdTit tdTit62">公司地址：</span>
                <div class="con82">
                  <input type="text">
                  <input type="text">
                  <input type="text">
                </div>
                <div class="con83">
                  <input type="text" v-model="editedItem.jointGuarantor.companyAddress">
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit63">公司電話：</span>
                <div class="con84">
                  <input type="text" v-model="editedItem.jointGuarantor.companyPhone">
                </div>
                <span class="tdTit tdTit63-1">分機</span>
                <div class="con84-1">
                  <input type="text">
                </div>
                <span class="tdTit tdTit64">行動電話：</span>
                <div class="con85">
                  <input type="text" v-model="editedItem.jointGuarantor.cellphone">
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table17-->
        </div><!--area4-->
        <div class="area4">
          <table class="table13">
            <thead>
            <tr>
              <th colspan="5">保證人二</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td width="170px">
                <span class="tdTit tdTit47">姓名：</span>
                <div class="con63">
                  <input type="text"  >
                </div>
              </td>
              <td width="205px">
                <span class="tdTit tdTit48">身分證字號：</span>
                <div class="con64">
                  <input type="text"  >
                </div>
              </td>
              <td width="157px">
                <span class="tdTit tdTit49">生日：</span>
                <div class="con65">
                  <input type="text"   class="y">年
                  <input type="text"   class="m">月
                  <input type="text"   class="d">日
                </div>
              </td>
              <td width="157px">
                <span class="tdTit tdTit50">婚姻狀態：</span>
                <div class="con66">
                  <span class="checkbox"><input type="checkbox"></span>已婚
                  <span class="checkbox"><input type="checkbox"></span>未婚
                  <span class="checkbox"><input type="checkbox"></span>其他
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit51">關係：</span>
                <div class="con67">
                  <input type="text"  >
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table13-->
          <table class="table14-2">
            <tbody>
            <tr>
              <td width="305px">
                <span class="tdTit tdTit52-2">學歷：</span>
                <div class="con68-2">
                  <span class="checkbox"><input type="checkbox"></span>碩士以上
                  <span class="checkbox"><input type="checkbox"></span>大學
                  <span class="checkbox"><input type="checkbox"></span>專科
                  <span class="checkbox"><input type="checkbox"></span>高中職
                  <span class="checkbox"><input type="checkbox"></span>初中及以下
                </div>
              </td>
              <td width="227px">
                <span class="tdTit tdTit53">月收入：NT</span>
                <div class="con69">
                  <input type="text"  >
                  <span class="txt">元</span>
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit54-2">行業別：</span>
                <div class="con70">
                  <input type="text"  >
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table14-2-->
          <table class="table15-2">
            <tbody>
            <tr>
              <td width="374px">
                <span class="tdTit tdTit55">任職公司：</span>
                <div class="con71">
                  <input type="text"  >
                </div>
              </td>
              <td width="236px">
                <span class="tdTit tdTit56-2">職稱：</span>
                <div class="con72">
                  <input type="text"  >
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit57-2">年資：</span>
                <div class="con73-2">
                  <input type="text"  >
                  <span class="txt">年</span>
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table15-2-->
          <table class="table16">
            <tbody>
            <tr>
              <td width="532px">
                <span class="tdTit tdTit58">戶籍地址：</span>
                <div class="con74">
                  <input type="text"  >
                  <input type="text"  >
                  <input type="text"  >
                </div>
                <div class="con75">
                  <input type="text"  >
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit59">戶籍電話：</span>
                <div class="con76">
                  <input type="text"  >
                </div>
                <div class="con77">
                  <span class="checkbox"><input type="checkbox"></span>自有<span class="checkbox"><input type="checkbox"></span>家人<input type="text"   class="input1"><br>
                  <span class="checkbox"><input type="checkbox"></span>租賃，&nbsp;居住<input type="text"   class="input2">年
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="tdTit tdTit60">通訊地址：</span>
                <div class="con78">
                  <input type="text"  >
                  <input type="text"  >
                  <input type="text"  >
                </div>
                <div class="con79">
                  <input type="text"  >
                </div>
                <div class="con79-1">
                  <span class="checkbox"><input type="checkbox"></span>同戶籍<br>
                  <span class="checkbox"><input type="checkbox"></span>同公司
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit61">通訊電話：</span>
                <div class="con80">
                  <input type="text"  >
                </div>
                <div class="con81">
                  <span class="checkbox"><input type="checkbox"></span>自有<span class="checkbox"><input type="checkbox"></span>家人<input type="text"   class="input1"><br>
                  <span class="checkbox"><input type="checkbox"></span>租賃，&nbsp;居住<input type="text"   class="input2">年
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table16-->
          <table class="table17">
            <tbody>
            <tr>
              <td width="532px">
                <span class="tdTit tdTit62">公司地址：</span>
                <div class="con82">
                  <input type="text"  >
                  <input type="text"  >
                  <input type="text"  >
                </div>
                <div class="con83">
                  <input type="text"  >
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit63">公司電話：</span>
                <div class="con84">
                  <input type="text"  >
                </div>
                <span class="tdTit tdTit63-1">分機</span>
                <div class="con84-1">
                  <input type="text"  >
                </div>
                <span class="tdTit tdTit64">行動電話：</span>
                <div class="con85">
                  <input type="text"  >
                </div>
              </td>
            </tr>
            </tbody>
          </table><!--table17-->
        </div><!--area4-->
        <div class="bottom">
          <ul>
            <li>1.本文件所提供之內容均為真實，並同意和潤企業為與申請事項有關之個人資料之搜集、利用及處理，如有不實，申請人等願付一切法律責任。</li>
            <li>2.本文件背面尚有個人資料運用告知同意書。</li>
            <li>3.<span>請翻至背面詳閱後簽名。</span></li>
          </ul>
          <div class="contact">
            <ul>
              <li>
                <div class="d1">聯絡人一：
                  <div class="con86">
                    <input type="text" v-model="editedItem.firstContact.name">
                  </div>
                </div>
                <div class="d2">關係：
                  <div class="con87">
                    <input type="text" v-model="editedItem.firstContact.type">
                  </div>
                </div>
                <div class="d3">手機：
                  <div class="con88">
                    <input type="text" v-model="editedItem.firstContact.cellphone">
                  </div>
                </div>
              </li>
              <li>
                <div class="d1">聯絡人二：
                  <div class="con86">
                    <input type="text" v-model="editedItem.secondContact.name">
                  </div>
                </div>
                <div class="d2">關係：
                  <div class="con87">
                    <input type="text" v-model="editedItem.secondContact.type">
                  </div>
                </div>
                <div class="d3">手機：
                  <div class="con88">
                    <input type="text" v-model="editedItem.secondContact.cellphone">
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div><!--bottom-->
        <div class="bt-left">FR-BA-062-005</div>
        <div class="bt-right">般1-11204</div>
      </div><!--page1-->
      <div class="page page2">
        <h1>個人資料運用告知同意書<span></span></h1>
        <p class="p1">和潤企業股份有限公司（以下稱本公司）依據個人資料保護法（以下稱個資法）規定，向&nbsp;&nbsp;台端告知並說明下列事項，請&nbsp;&nbsp;&nbsp;&nbsp;台端詳閱：</p>
        <ul>
          <li> <span class="tit">一、</span>蒐集之目的：（一）辦理租賃、分期付款買賣、資金貸與、應收帳款受讓暨管理等相關業務（二）契約、類似契約或其他法律關係事務、核貸與授信業務、帳務管理及債權交易業務、債權整貼現及收買業務、徵信業務（含上下游及同業間彼此照會、租賃同業、關係企業、票信等照會之徵信行為）（三）調查、統計與研究分析：客戶管理、服務及消費者保護、其他經營合於營業登記項目或組織章程所定之業務（四）包括本公司、關係企業及相關業務委外機構等，於行銷或合作目的之範圍內使用。</li>
          <li> <span class="tit">二、</span>蒐集之個人資料類別：識別類（包括但不限姓名、出生年月日、國民身分證統一編號、護照號碼）、特徵類、家庭情形、社會情況、教育、考選、技術或其他專業、受僱情形、財務細節、商業資訊，含與本公司相關業務之申請書或契約書內容及其他具有正當合理關連之紀錄，但仍以本公司與&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;台端往來之相關業務所實際蒐集之個人資料為準。</li>
          <li> <span class="tit">三、</span>個人資料利用之期間、對象、地區及方式
            <ul class="ul2">
              <li><span class="tit">（一）</span>期間：個人資料蒐集之特定目的存續期間、依相關法令或契約約定之保存期限（商業會計法等）或本公司因執行業務所必須之保存期間。</li>
              <li><span class="tit">（二）</span>對象：本公司、本公司之關係企業暨其母&nbsp;(&nbsp;子&nbsp;)&nbsp;(&nbsp;孫&nbsp;)&nbsp;公司、通匯銀行、財團法人金融聯合徵信中心、票據交換所、財金資訊公司、中華徵信所股份有限公司及其關係企業與協力廠商、代理收付款項業務機構、業務委外機構、未受中央目的事業主管機關限制之國際傳輸個人資料之接收者、本公司之共同行銷、合作推廣對象或交互運用客戶資料公司、本公司所屬同業公會、其他與本公司有業務往來之機構、依法有調查權機關或金融監理機關。 </li>
              <li><span class="tit">（三）</span>地區：前揭利用對象之國內外營業所在地及未受中央目的事業主管機關限制之國際傳輸個人資料之接收者營業所在地。 </li>
              <li><span class="tit">（四）</span>方式：以自動化機器或其他非自動化方式之利用方式（例如使用電子文件、紙本或其他合於當時科技之適當方式）。</li>
            </ul>
          </li>
          <li> <span class="tit">四、</span>依據個資法第三條規定，台端就本公司保有&nbsp;&nbsp;&nbsp;&nbsp;台端之個人資料得行使下列權利：
            <ul class="ul2">
              <li><span class="tit">（一）</span>得向本公司查詢、請求閱覽或請求製給複本，本公司依法得酌收必要成本費用。</li>
              <li><span class="tit">（二）</span>得向本公司請求補充或更正，惟依法&nbsp;&nbsp;&nbsp;&nbsp;台端應為適當之釋明。 </li>
              <li><span class="tit">（三）</span>得向本公司請求停止蒐集、處理或利用及請求刪除，惟依法本公司依法執行業務所必須，得不依&nbsp;&nbsp;&nbsp;&nbsp;台端請求為之。惟&nbsp;&nbsp;&nbsp;&nbsp;台端若提出前述要求，應自行承擔因此所生之損失或損害，包括但不限於本公司可能無法提供或提前終止&nbsp;&nbsp;&nbsp;&nbsp;台端所需之商品及服務或有任何交易往來。</li>
            </ul>
          </li>
          <li> <span class="tit">五、</span>若於相關事實或法律關係存續期間或法令規定期間外，本公司所蒐集&nbsp;&nbsp;&nbsp;&nbsp;台端個人資料仍得為本公司、關係企業、合作廠商或主管機關核准經營業務之範圍，進行行銷活動或研究、統計之目的繼續使用。 </li>
          <li> <span class="tit">六、</span>台端得自由選擇是否提供相關個人資料，惟若不簽署本同意書，本公司將可能無法與&nbsp;&nbsp;&nbsp;&nbsp;台端有任何往來或提供所需商品或服務，對&nbsp;&nbsp;&nbsp;&nbsp;台端所提供服務之範圍亦將會受到限制，包括優惠活動等。另依法，縱&nbsp;&nbsp;&nbsp;&nbsp;台端不簽署本同意書,，本公司仍有權基於法令及契約約定（含契約約定之服務、催收等）範圍內蒐集、處理及利用本人提供之個人資料。</li>
          <li> <span class="tit">七、</span>為響應節能減碳，本公司將推動發票無紙化，不再主動提供個人紙本電子發票證明聯，發票資訊可至本公司官 網查詢。若有紙本發票需求，請洽本公司客服人員。<br>本人同意此交易之發票由和潤企業將發票逕行上傳至和潤企業發票平台。</li>
        </ul>
        <p class="p2">立同意書人已清楚瞭解及知悉上開告知事項，並確實同意無誤。</p>
        <p class="p3">此致<span>和潤企業股份有限公司</span></p>
        <div class="box1">
          <p class="tit">立同意書人確認本文件所提供之內容均為真實，如有不實，願付一切法律責任。</p>
          <p>立同意書人(車主)：<span class="s1"></span>
            <img
              class="box"
              :src="signImageSrc('customer')"
              @click="showSignDialog('customer')"
            />
          </p>
          <v-layout>
            <v-flex md6>
              <p>立同意書人(連帶保證人一)：<span class="s2"></span>
                <img
                  class="box"
                  :src="signImageSrc('jointGuarantor')"
                  @click="showSignDialog('jointGuarantor')"
                />
              </p>
            </v-flex>
            <v-flex md6>
              <p>立同意書人(連帶保證人二)：<span class="s3"></span></p>
            </v-flex>
          </v-layout>


          <div class="date">中華民國<span class="y"></span>年<span class="m"></span>月<span class="d"></span>日</div>
        </div><!--box1-->
        <div class="box2">
          <p>對保人茲證明立同意書人於本文件之簽章皆為真正無誤，如有不實，願負一切法律責任。</p>
          <div class="name">對保人：<span></span></div>
          <div class="date">對保日：<span></span></div>
        </div><!--box2-->
        <div class="bt-left">FR-BA-062-005</div>
        <div class="bt-right">般1-11204</div>


      </div><!--page2-->

      <!--page1-->
      <div class="btn">
        <span class="mr-2 subheading red--text" v-if="saveLoading">案件上傳中 請勿關閉視窗</span>
        <v-btn class="primary" dark text :loading="saveLoading" @click="save">確認上傳</v-btn>
        <!-- <a href @click.prevent="save">確認上傳</a> -->
      </div>

      <v-card>
        <v-card-title>
          <span class="title">PDF檔 / Zip檔</span>
        </v-card-title>
        <v-layout m-2 v-if="(editedItem.imageList && editedItem.imageList.length)"
                  v-for="(url, i) in editedItem.imageList" :key="i">
          <v-flex>
            <a class="subheading m-2" :href="url" target="_blank">
              檔案 #{{ i+1}}
            </a></v-flex>
        </v-layout>
        <v-layout ml-2 v-if="(editedItem.fileList && editedItem.fileList.length)"
                  v-for="(file, i) in editedItem.fileList" :key="i">
          <v-flex ml-2>
            <a class="subheading" :href="file.data" target="_blank">
              {{file.imageName}}
            </a></v-flex>
        </v-layout>
      </v-card>

      <v-dialog
        fullscreen hide-overlay
        v-model="signDialog.visible">
        <v-card>
          <v-card-text>
            <draw-canvas :visible="signDialog.visible" :background-color="'#e6e6e6'" @handleDownloadSign="handleDownloadSign"  @closeEvent="handleDownloadClose"></draw-canvas>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--彈出視窗-->
      <alert-view
        :visible="messageDialog.visible"
        :title="messageDialog.title"
        :content="messageDialog.content"
        :show-cancel="messageDialog.showCancel"
        @confirmEvent="messageDialog.confirm"
        @cancelEvent="messageDialog.cancel"
      ></alert-view>
    </div>
  </v-app>
  <!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DrawCanvas from "@/components/DrawCanvas";
import ApplicationModel from "../../models/ApplicationModel";
import AlertView from "@/components/AlertView";
import { sortApplicationItem } from '@/pages/utils/tool';

export default {
  name: "loanhfcV202105EditView",
  props: {
    item: Object
  },
  components: { DrawCanvas, AlertView },
  data() {
    return {
      saveLoading: false,
      itemDetail: null,
      loadingText: "上傳中...",
      checkedImage: require("../../assets/images/checked.png"),
      createDate: "",
      signDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      signKey:''
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    editedItem() {
      return this.itemDetail;
    },
    publicYearList() {
      const start = new Date().getFullYear();
      const end = 1911;
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i}`, name: `${i}年` });
      }
      return list;
    },
    publicMonthList() {
      return [
        { name: "01月", key: "01" },
        { name: "02月", key: "02" },
        { name: "03月", key: "03" },
        { name: "04月", key: "04" },
        { name: "05月", key: "05" },
        { name: "06月", key: "06" },
        { name: "07月", key: "07" },
        { name: "08月", key: "08" },
        { name: "09月", key: "09" },
        { name: "10月", key: "10" },
        { name: "11月", key: "11" },
        { name: "12月", key: "12" }
      ];
    },
    yearList() {
      const start = new Date().getFullYear();
      const end = 1911;
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i - 1911}`, name: `${i - 1911}` });
      }
      return list;
    },
    monthList() {
      return [
        { name: "01", key: "01" },
        { name: "02", key: "02" },
        { name: "03", key: "03" },
        { name: "04", key: "04" },
        { name: "05", key: "05" },
        { name: "06", key: "06" },
        { name: "07", key: "07" },
        { name: "08", key: "08" },
        { name: "09", key: "09" },
        { name: "10", key: "10" },
        { name: "11", key: "11" },
        { name: "12", key: "12" }
      ];
    },
    dayList() {
      const startIndex = 1;
      const list = [];
      for (let i = startIndex; i <= 31; i++) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    }
  },
  created() {
    // this.itemDetail.displayId = '';
  },
  mounted() {
    this.checkItemExist();
  },
  methods: {
    ...mapActions(["saveFinanceCreditData", "fetchCreditProductInfo", "saveFinanceInfo"]),
    signImageSrc(itemPath) {
      console.log(`sign == ${JSON.stringify(this.editedItem)}`);
      let source = null;
      if (itemPath === "customer") {
        if (this.editedItem.laonhfcInfo.signImage1) {
          source = this.editedItem.laonhfcInfo.signImage1;
        } else if (this.editedItem.signImage0) {
          source = this.editedItem.signImage0;
        } else if (this.editedItem.signImage0Url) {
          source = this.editedItem.signImage0Url;
        }
      } else if (itemPath === "jointGuarantor") {
        if (this.editedItem.laonhfcInfo.signImage2) {
          source = this.editedItem.laonhfcInfo.signImage2;
        } else if (this.editedItem.signImage3) {
          source = this.editedItem.signImage3;
        } else if (this.editedItem.signImage3Url) {
          source = this.editedItem.signImage3Url;
        }
      } else if (itemPath === "caseOfficer") {
        if (this.editedItem.laonhfcInfo.signImage3) {
          source = this.editedItem.laonhfcInfo.signImage3;
        } else if (this.editedItem.laonhfcInfo.signimage3Url) {
          source = this.editedItem.laonhfcInfo.signimage3Url;
        }
      }
      return source;
    },
    getCaseProduct(item) {
      if (item.productId === "0") {
        return "機車原融";
      }
      if (item.productId === "1") {
        return "借新還舊";
      }
      if (item.productId === "2") {
        return "他行代償";
      }
      return "機車原融";
    },
    async checkItemExist() {
      this.editedIndex = this.$route.query.editIndex;
      // 編輯
      let results = {};
      if (this.editedIndex === 0 || this.editedIndex === "0") {
        const caseId = this.$route.query.caseId;
        results = await this.fetchCreditProductInfo({ caseId: caseId });
      }
      const result = results.length > 0 ? results[0] : this.item;
      this.itemDetail = sortApplicationItem(result);
      if(this.itemDetail.platform !== 1) {
        this.itemDetail.caseId = Math.uuidFast();
        this.itemDetail.platform = 1;
      }

      this.itemDetail.category = parseInt(this.$route.query.caseCategory, 10);
      console.log(`this.itemDetail === ${JSON.stringify(this.itemDetail)}`) ;
      let customerBirthdayYaer = this.itemDetail.customer.birthdayInfo.year;
      this.itemDetail.customer.birthdayInfo.year = this.convertToRepublic(customerBirthdayYaer)

      let jointGuarantorBirthdayYaer = this.itemDetail.jointGuarantor.birthdayInfo.year;
      this.itemDetail.jointGuarantor.birthdayInfo.year = this.convertToRepublic(jointGuarantorBirthdayYaer)
    },
    showSignDialog(key) {
      this.signKey = key;
      this.signDialog.visible = true;
    },
    handleDownloadSign(image) {
      if (this.signKey === "customer") {
        this.itemDetail.laonhfcInfo.signImage1 = image;
      } else if (this.signKey === "jointGuarantor") {
        this.itemDetail.laonhfcInfo.signImage2 = image;
      } else if (this.signKey === "caseOfficer") {
        this.itemDetail.laonhfcInfo.signImage3 = image;
      }
      this.signDialog.visible = false;
      this.signDialog.confirm = () => {
        if (this.signKey === "customer") {
          this.itemDetail.laonhfcInfo.signImage1 = image;
        } else if (this.signKey === "jointGuarantor") {
          this.itemDetail.laonhfcInfo.signImage2 = image;
        } else if (this.signKey === "caseOfficer") {
          this.itemDetail.laonhfcInfo.signImage3 = image;
        }
        this.signDialog.laonhfcInfo = false;
      };
    },
    handleDownloadClose() {
      this.signDialog.visible = false
    },
    checkFormData() {
      if (this.itemDetail.customer.memberId === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫身分證！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      // if (this.itemDetail.customer.birthday === "") {
      //   this.showMessageDialog(
      //     "錯誤",
      //     "請填寫生日！",
      //     true,
      //     () => {},
      //     () => {}
      //   );
      //   return false;
      // }
      if (this.itemDetail.customer.cellphone === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫行動電話！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.itemDetail.company.name === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫公司名稱！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.itemDetail.company.phone === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫公司電話！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      return true;
    },
    async save() {
      console.log(`saveFinanceCreditData ${JSON.stringify(this.itemDetail)}`);
      this.itemDetail.parentAgent = {
          agentId: this.getUserInfo.agentId ? this.getUserInfo.agentId : 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2',
          agentNumber: this.getUserInfo.agentNumber ? this.getUserInfo.agentNumber : '000000',
          displayName: this.getUserInfo.displayName ? this.getUserInfo.displayName : '總公司',
          parentAgent: {
            agentId: this.getUserInfo.parentAgent ? this.getUserInfo.parentAgent.agentId : 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2',
            rootAgent: 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2'
          },
          salesName: this.getUserInfo.salesName ? this.getUserInfo.salesName : '總公司',
      };
      if (this.checkFormData()) {
        try {
          this.saveLoading = true;
          delete this.itemDetail.signImage0;
          delete this.itemDetail.signImage1;
          delete this.itemDetail.signImage2;
          delete this.itemDetail.signImage3;

          let customerBirthdayYaer = this.itemDetail.customer.birthdayInfo.year;
          this.itemDetail.customer.birthdayInfo.year = this.convertToAdYear(customerBirthdayYaer)

          let jointGuarantorBirthdayYaer = this.itemDetail.jointGuarantor.birthdayInfo.year;
          this.itemDetail.jointGuarantor.birthdayInfo.year = this.convertToAdYear(jointGuarantorBirthdayYaer)

          console.log(`this.itemDetail === ${ JSON.stringify(this.itemDetail)}`);
          const saveData = JSON.parse(JSON.stringify(this.itemDetail));
          const result = await this.saveFinanceCreditData(saveData);
          const resultInfo = await this.saveFinanceInfo(saveData);
          console.log(`saveFinanceCreditData ${JSON.stringify(resultInfo)}`);
          this.saveLoading = false;
        } catch (e) {
          console.log(e);
          this.showMessageDialog(
            "儲存失敗",
            `${JSON.stringify(e)}`,
            true,
            () => {},
            () => {}
          );
        }
      }
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.content = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    paymentSlip(type) {
      if (type === 0) {
        this.itemDetail.paymentInfo.debitNote.isDebitNote = !this.itemDetail
          .paymentInfo.debitNote.isDebitNote;
      } else if (type === 1) {
        this.itemDetail.paymentInfo.debitNote.isRegistration = !this.itemDetail
          .paymentInfo.debitNote.isRegistration;
      } else if (type === 2) {
        this.itemDetail.paymentInfo.debitNote.isMailingAddress = !this
          .itemDetail.paymentInfo.debitNote.isMailingAddress;
      } else if (type === 3) {
        this.itemDetail.paymentInfo.debitNote.isCompanyAddress = !this
          .itemDetail.paymentInfo.debitNote.isCompanyAddress;
      }
      this.itemDetail.paymentInfo.debitNote.isDebitNote =
        this.itemDetail.paymentInfo.debitNote.isRegistration ||
        this.itemDetail.paymentInfo.debitNote.isMailingAddress ||
        this.itemDetail.paymentInfo.debitNote.isCompanyAddress;

      if (
        this.itemDetail.paymentInfo.debitNote.isDebitNote ||
        this.itemDetail.paymentInfo.debitNote.isRegistration ||
        this.itemDetail.paymentInfo.debitNote.isMailingAddress ||
        this.itemDetail.paymentInfo.debitNote.isCompanyAddress
      ) {
        this.itemDetail.paymentInfo.isAutoBillPay = false;
      }
    },
    autoPayment() {
      this.itemDetail.paymentInfo.isAutoBillPay = !this.itemDetail.paymentInfo
        .isAutoBillPay;
      if (this.itemDetail.paymentInfo.isAutoBillPay) {
        this.itemDetail.paymentInfo.debitNote.isDebitNote = false;
        this.itemDetail.paymentInfo.debitNote.isRegistration = false;
        this.itemDetail.paymentInfo.debitNote.isMailingAddress = false;
        this.itemDetail.paymentInfo.debitNote.isCompanyAddress = false;
      }
    },
    convertToAdYear(year){
      if(!year) {
        return ''
      }
      const copyYear = `${year}`
      if(copyYear.length > 3) {
        return year
      }
      const value = Number(copyYear)
      if(value === NaN) {
        return year
      }
      return `${(1911 + value)}`
    },
    convertToRepublic(year){
      if(!year) {
        return ''
      }
      const copyYear = `${year}`
      if(copyYear.length !== 4) {
        return year
      }
      const value = Number(copyYear)
      if(value === NaN) {
        return year
      }
      return `${(value - 1911)}`
    }
  }
};
</script>

<style scoped src="../../assets/css/loanhfc_v202105_edit.css">
</style>

<style scoped>
.box {
  position: absolute;
  width: 125px;
  height: 35px;
  bottom: 0px;
}
.btn {
  text-align: center;
}
.btn a {
  display: inline-block;
  text-decoration: none;
  border: 1px solid #2b7fa5;
  background: #c2dfec;
  text-align: center;
  line-height: 30px;
  padding: 0 20px;
  font-size: 16px;
  margin: 0 auto 100px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  color: #10455d;
}
.btn a:hover {
  background: #189ad4;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/loanhfcV202105EditView.vue